import React from "react";
import "./Page.css";

const Terms = () => (
  <div className="ap-page-container">
    <h1>Terms of Service</h1>
    <p>Last updated: January 11, 2026</p>

    <div className="ap-content-section">
      <h2>1. Agreement to Terms</h2>
      <p>
        These Terms of Service constitute a legally binding agreement made between you, whether
        personally or on behalf of an entity (&quot;you&quot;) and AutoPromote (&quot;we&quot;,
        &quot;us&quot;, or &quot;our&quot;), concerning your access to and use of the AutoPromote
        website and services.
      </p>

      <h2>2. Description of Service</h2>
      <p>
        AutoPromote provides social media automation tools that allow users to schedule, upload, and
        manage content across multiple platforms (&quot;Service&quot;). You agree that the Service
        allows you to cross-post content to third-party platforms via their respective APIs.
      </p>

      <h2>3. User Representations</h2>
      <p>
        By using the Services, you represent and warrant that: (1) all registration information you
        submit will be true, accurate, current, and complete; (2) you will maintain the accuracy of
        such information; (3) you have the legal capacity and you agree to comply with these Terms
        of Service; and (4) your use of the Services will not violate any applicable law or
        regulation.
      </p>

      <h2>4. Platform Compliance</h2>
      <p>
        You expressly agree to comply with the Terms of Service, Community Guidelines, and policies
        of all third-party platforms connected to your AutoPromote account, including but not
        limited to YouTube, TikTok, Twitter/X, LinkedIn, and Instagram. You acknowledge that
        AutoPromote is not responsible for any enforcement action taken by these platforms against
        your accounts due to your content or activity.
      </p>

      <h2>5. Prohibited Activities</h2>
      <p>
        You may not access or use the Services for any purpose other than that for which we make the
        Services available. The Services may not be used in connection with any commercial endeavors
        except those that are specifically endorsed or approved by us. Prohibited activity includes
        uploading content that is illegal, hateful, violent, or infringes on the intellectual
        property rights of others.
      </p>

      <h2>6. Intellectual Property Rights</h2>
      <p>
        Unless otherwise indicated, the Services and their entire contents, features, and
        functionality (including but not limited to all information, software, text, displays,
        images, video, and audio) are owned by AutoPromote, its licensors, or other providers of
        such material and are protected by copyright, trademark, and other intellectual property
        laws.
      </p>

      <h2>7. Termination</h2>
      <p>
        We may terminate or suspend your access immediately, without prior notice or liability, for
        any reason whatsoever, including without limitation if you breach the Terms. Upon
        termination, your right to use the Service will immediately cease.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        In no event shall AutoPromote, nor its directors, employees, partners, agents, suppliers, or
        affiliates, be liable for any indirect, incidental, special, consequential or punitive
        damages, including without limitation, loss of profits, data, use, goodwill, or other
        intangible losses, resulting from your access to or use of or inability to access or use the
        Service.
      </p>

      <h2>9. Governing Law</h2>
      <p>
        These Terms shall be governed and construed in accordance with the laws of the jurisdiction
        in which AutoPromote operates, without regard to its conflict of law provisions.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        In order to resolve a complaint regarding the Services or to receive further information
        regarding use of the Services, please contact us at support@autopromote.com.
      </p>
    </div>
  </div>
);

export default Terms;
